if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.hydrate();
        super.show(opener);
        this.showActiveMedia();
      }

      // The media lives in a <template> so the page builds none of it on load.
      // Move it into the dialog the first time the modal is opened.
      hydrate() {
        const template = this.querySelector('template[data-media-content]');
        if (!template) return;
        const container = this.querySelector('[role="document"]');
        if (container) container.appendChild(template.content);
        template.remove();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy?.getAttribute('data-media-id');
        if (!openedMediaId) return;

        this.querySelectorAll(`[data-media-id]:not([data-media-id="${openedMediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${openedMediaId}"]`);
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
